import MainTitle from "../../components/ui/MainTitle/MainTitle";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useGetAllLegalPagesQuery } from "../../api/queries";
import { ILegalPageListItem, LEGAL_PAGES } from "../../models/LegalPage";
import dots from "../../assets/images/icons/dots.svg";
import viewIcon from "../../assets/images/icons/eye-dark.svg";

const TermsAndPolicies = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data = [], isLoading } = useGetAllLegalPagesQuery();

  const columns: ColumnsType<ILegalPageListItem> = [
    {
      title: t("Page"),
      render: (data: ILegalPageListItem) => t(LEGAL_PAGES[data.key].labelKey),
    },
    {
      title: t("AddressOnTheSite"),
      render: (data: ILegalPageListItem) => LEGAL_PAGES[data.key].sitePath,
    },
    {
      title: t("Languages"),
      render: (data: ILegalPageListItem) =>
        data.languages.length ? data.languages.join(" • ") : t("NoTextYet"),
    },
    {
      title: t("LastEdited"),
      render: (data: ILegalPageListItem) =>
        data.updatedAt ? dayjs(data.updatedAt).format("DD-MM-YYYY HH:mm") : "-",
    },
    {
      title: t("Action"),
      width: "150px",
      render: (data: ILegalPageListItem) => (
        <div className={"action-wrapper"}>
          <img src={dots} alt={"action"} />
          <ul className={"dropdown"}>
            <li
              className={"dropdown-item"}
              onClick={() => navigate(`/terms-and-policies/${data.key}`)}
            >
              <img src={viewIcon} alt={"Edit"} />
              {t("Edit")}
            </li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div className={"page-content gyms-page"}>
      <MainTitle text={t("TermsAndPolicies")} />
      <Table
        className={"table"}
        columns={columns}
        rowKey={(record) => record.key}
        dataSource={data}
        pagination={false}
        loading={isLoading}
      />
    </div>
  );
};

export default TermsAndPolicies;
